// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const YoutubeIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Youtube/brand"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.392 4.466C5.117 4 11.993 4 11.993 4s6.89 0 8.615.494c.938.254 1.685 1.031 1.93 2.005.476 1.794.462 5.522.462 5.522s0 3.714-.462 5.494a2.79 2.79 0 0 1-1.93 2.019C18.883 20 11.993 20 11.993 20s-6.862 0-8.601-.48c-.938-.268-1.685-1.045-1.944-2.02C1 15.735 1 12.007 1 12.007s0-3.714.448-5.508c.259-.974 1.02-1.765 1.944-2.033ZM10 16l6-3.992L10 8v8Z",
  clipRule: "evenodd"
}));
export default YoutubeIcon;